import { render } from "./BottomLinks.vue?vue&type=template&id=8ce0c4c6&scoped=true"
const script = {}

import "./BottomLinks.vue?vue&type=style&index=0&id=8ce0c4c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ce0c4c6"]])

export default __exports__